import { render, staticRenderFns } from "./AppColor.vue?vue&type=template&id=4af5f97a&scoped=true"
import script from "./AppColor.vue?vue&type=script&lang=js"
export * from "./AppColor.vue?vue&type=script&lang=js"
import style0 from "./AppColor.vue?vue&type=style&index=0&id=4af5f97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5f97a",
  null
  
)

export default component.exports